<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card>
          <form @submit="salvar">
            <vs-input
              size="large"
              label-placeholder="Apelido do Computador"
              required
              v-model="title"
              autocomplete="off"
              class="w-full md:w-1/2 mb-6"
              autofocus
            />

            <vs-input
              size="large"
              label-placeholder="Licença do Computador"
              required
              v-model="licencekey"
              autocomplete="off"
              class="w-full md:w-1/2"
            />

            <vs-button class="w-full mt-4 md:w-auto" @click="salvar">
              <i class="far fa-save"></i> {{$t("RegisterLicenseComputer")}}
            </vs-button>

            <vs-button color="danger" type="border" class="w-full ml-4 mt-4 md:w-auto" to="/dispositivo">
              <i class="far fa-times"></i> {{$t("Cancel")}}
            </vs-button>
            <button type="submit" style="display: none"></button>
          </form>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      licencekey: ""
    };
  },
  methods: {
    salvar: function() {
      this.$api
        .post("/api/v1/desktop/register", {
          title: this.title,
          licencekey: this.licencekey
        })
        .then(() => {
          this.$router.push("/dispositivo");

          this.$vs.notify({
            time: 6000,
            text: "Licença Cadastrada com Sucesso",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: error.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    }
  }
};
</script>
